require('../../vendor/adaptivemedia/atlantis-core/resources/js/bootstrap.js');
